import { DependencyList, EffectCallback, useEffect } from 'react';

export const useMountEffect = (effect: EffectCallback, props: DependencyList = []) => {
    useEffect(effect, props);
};